import { ContentEdit } from "./ContentEdit";

export default ContentEdit;
